import Personal from './Personal'

export default Personal
